import { jsonb as JsonbType } from '../../@types/jsonb';
import FilterBar, { IncFilterOpsType } from '../../components/FilterBar';

const initialJsonb: JsonbType = {
  jsonb: {
    driverVeiculo: {
      'Tipo Veículo': {
        _rule_type: 'containment_multiple',
        contains: [],
      },
    },
    driverVitima: {
      'Gravidade da Lesão': {
        _rule_type: 'containment_multiple',
        contains: [],
      },
    },
    driverIncidenteDetails: {
      Natureza: {
        _rule_type: 'containment',
        contains: [],
      },
      Severidade: {
        _rule_type: 'containment',
        contains: [],
      },
    },
  },
};

const initialFilterOps: IncFilterOpsType = {
  endDate: '',
  startDate: '',
  veiculos: [],
  gravidades: [],
  location: [],
  tipoAcidentes: [],
  bairros: '',
  vias: '',
  regionais: '',
  drawPolygon: {},
};

const loadFilterOps = (): IncFilterOpsType => {
  let filterOpsObj: IncFilterOpsType = initialFilterOps;
  const loadedFilterOps = localStorage.getItem('incFilterOps');

  // Carrega a filtragem do Local Storage e armazena no filterOps
  if (loadedFilterOps) {
    filterOpsObj = JSON.parse(loadedFilterOps);
  }

  return filterOpsObj;
};

const loadJsonbStorage = (): JsonbType => {
  // Carrega os 14 Sinistros
  const loadedFilterOps = localStorage.getItem('incFilterOps');
  let jsonbObj: JsonbType = initialJsonb;

  if (loadedFilterOps) {
    const parsedFilters: IncFilterOpsType = JSON.parse(loadedFilterOps);

    const locationTypes: Array<string | string[]> = [];

    parsedFilters.veiculos.map((item) => {
      locationTypes.push(item);
      locationTypes.push([item]);
    });

    jsonbObj = {
      jsonb: {
        driverIncidenteDetails: {
          Natureza: {
            _rule_type: 'containment',
            contains: [],
          },
          Severidade: {
            _rule_type: 'containment',
            contains: [],
          },
          'Location Type': {
            _rule_type: 'containment',
            contains: locationTypes,
          }
        },
      },
    };
    return jsonbObj;
  }
  return jsonbObj;
};

export { loadFilterOps, loadJsonbStorage };